import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import so from "./locales/so.json";
import de from "./locales/de.json";
import pt from "./locales/pt.json";

// Use https://flagcdn.com SVG circle flags — consistent across all OS/browsers.
// `flag` is an ISO 3166-1 alpha-2 code (lowercase). `so` is mapped to Somalia.
export const LANGUAGES = [
  { code: "en", label: "English", flag: "gb" },
  { code: "ar", label: "العربية", flag: "ae", rtl: true },
  { code: "fr", label: "Français", flag: "fr" },
  { code: "es", label: "Español", flag: "es" },
  { code: "de", label: "Deutsch", flag: "de" },
  { code: "pt", label: "Português", flag: "pt" },
  { code: "so", label: "Soomaali", flag: "so" },
];

export const flagUrl = (code) => `https://flagcdn.com/w40/${code}.png`;
export const flagUrl2x = (code) => `https://flagcdn.com/w80/${code}.png`;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      fr: { translation: fr },
      es: { translation: es },
      so: { translation: so },
      de: { translation: de },
      pt: { translation: pt },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ar", "fr", "es", "so", "de", "pt"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
      lookupLocalStorage: "ofunded_lang",
    },
  });

// Apply dir + lang attributes when language changes
function applyDir(lng) {
  // Normalize BCP-47 / POSIX strings like "en-US@posix" to a supported base code.
  const base = (lng || "en").toLowerCase().split(/[-_@]/)[0];
  const supported = LANGUAGES.find((l) => l.code === base) ? base : "en";
  const isRTL = LANGUAGES.find((l) => l.code === supported)?.rtl;
  document.documentElement.setAttribute("lang", supported);
  document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
}
applyDir(i18n.language || "en");
i18n.on("languageChanged", applyDir);

export default i18n;
